import * as React from 'react'
import { useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TableHead } from '@mui/material'
import { SellerState } from '../../../../features/types'

interface Props {
    sellersData: SellerState[]
    isFetchingSellers: boolean
}

const SellersReportTable: React.FC<Props> = ({
    sellersData = [],
    isFetchingSellers = false,
}) => {
    const { formatMessage } = useIntl()

    return (
        <>
            {sellersData ? (
                <TableContainer
                    component={Paper}
                    sx={{ border: 1, borderColor: 'grey.100', borderRadius: 2 }}
                    elevation={0}
                >
                    <Table sx={{ minWidth: 500 }}>
                        <TableHead sx={{ bgcolor: 'grey.100' }}>
                            <TableRow>
                                <TableCell>
                                    #
                                </TableCell>
                                <TableCell>
                                    {formatMessage({ id: 'fullName' })}
                                </TableCell>

                                <TableCell align="right">
                                    {formatMessage({ id: 'numOfSales' })}
                                </TableCell>

                                <TableCell align="right">
                                    {formatMessage({ id: 'sumOfSales' })} KZT
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        {sellersData.length ? (
                            <TableBody>
                                {sellersData.map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell>
                                            {row.firstName + ' ' + row.lastName}
                                        </TableCell>
                                        <TableCell align="right">
                                            {row.numOfSales}
                                        </TableCell>
                                        <TableCell align="right">
                                            {row.sumOfSales} тг
                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        ) : (
                            !isFetchingSellers && (
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            component="th"
                                            scope="row"
                                            align="center"
                                            colSpan={4}
                                        >
                                            {formatMessage({ id: 'noData' })}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        )}

                    </Table>
                </TableContainer>
            ) : (
                <Box sx={{ p: 1 }}>{formatMessage({ id: 'noData' })}</Box>
            )}
        </>
    )
}

export default SellersReportTable
